<template>
  <div>
    <CRow>
      <!-- Filtro -->
      <CCol xs="12" sm="12" md="12" lg="4" xxl="4">
        <CCard>
          <CCardHeader class="d-flex justify-content-between">
            <b><i class="fas fa-calendar"></i>&nbsp;Reporte de Utilidades</b>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol xs="12" sm="12" md="12" lg="12" xxl="12">
                <CSelect label="Mes" size="sm" :value.sync="selectedMonth" :options="monthOptions" />
              </CCol>
              <CCol xs="12" sm="12" md="12" lg="12" xxl="12" class="d-flex align-items-end">
                <CButton type="button" color="primary" class="w-100" size="sm" @click="mtd_data">
                  <i class="fas fa-search"></i> Generar
                </CButton>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>

      <!-- Resumen -->
      <CCol xs="12" sm="12" md="12" lg="8" xxl="8" class="mb-2" v-if="data.length || expenses.length">
        <CRow>
          <CCol xs="12" sm="4">
            <CCard class="text-center border-success">
              <CCardBody>
                <h6 class="text-success mb-1"><i class="fas fa-arrow-up"></i> Total Ingresos</h6>
                <h4 class="text-success font-weight-bold">S/ {{ totalIngresos }}</h4>
              </CCardBody>
            </CCard>
          </CCol>
          <CCol xs="12" sm="4">
            <CCard class="text-center border-danger">
              <CCardBody>
                <h6 class="text-danger mb-1"><i class="fas fa-arrow-down"></i> Total Egresos</h6>
                <h4 class="text-danger font-weight-bold">S/ {{ totalEgresos }}</h4>
              </CCardBody>
            </CCard>
          </CCol>
          <CCol xs="12" sm="4">
            <CCard class="text-center" :class="utilidad >= 0 ? 'border-primary' : 'border-warning'">
              <CCardBody>
                <h6 class="mb-1" :class="utilidad >= 0 ? 'text-primary' : 'text-warning'">
                  <i class="fas fa-balance-scale"></i> Utilidad
                </h6>
                <h4 class="font-weight-bold" :class="utilidad >= 0 ? 'text-primary' : 'text-warning'">
                  S/ {{ utilidad }}
                </h4>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CCol>

      <!-- Tabla Ingresos -->
      <CCol xs="12" sm="12" md="12" lg="12" xxl="12">
        <CTableWrapper
          :items="data"
          :fields="fields"
          hover
          :striped="true"
          :border="true"
          small
          fixed
          caption="Ingresos (Citas)"
          icon="fas fa-coins"
          @mtdBack="mtdBack"
          :size="'md'"
          :withActions="'2%'"
        />
      </CCol>

      <!-- Tabla Egresos -->
      <CCol xs="12" sm="12" md="12" lg="12" xxl="12">
          <CRow class="mb-2">
            <CCol class="text-right">
              <CButton type="button" color="success" @click="mtd_open_modal">
                <i class="fas fa-minus-circle"></i> Registrar Egreso
              </CButton>
            </CCol>
          </CRow>
          
        <CTableWrapper
          :items="expenses"
          :fields="fieldsExpenses"
          hover
          :striped="true"
          :border="true"
          small
          fixed
          caption="Egresos"
          icon="fas fa-minus-circle"
          @mtdBack="mtdBack"
          :size="'md'"
          :withActions="'2%'"
        />
      </CCol>
      <cModalEgresos 
        @closeModalEgreso="closeModalEgreso" 
        :boo_modal="modalEgresos.modal_form" 
        :title="modalEgresos.title"
        @savedExpense="mtd_data"
        >
      </cModalEgresos>
    </CRow>
    
  </div>
</template>

<script>
import CTableWrapper from "../../components/shared/datatable/Table.vue";
import cModalEgresos from "./modals/cModalEgresos.vue";
import { mapActions } from "vuex";
import moment from "moment";

const fields = [
  { key: "index",          label: "N°",                 _style: "width:1%"  },
  { key: "date_formatted", label: "Fecha",              _style: "width:8%"  },
  { key: "name_client",    label: "Cliente",            _style: "width:12%" },
  { key: "barbers",        label: "Personal",           _style: "width:12%" },
  { key: "services",       label: "Servicios/Productos",_style: "width:18%" },
  { key: "method",         label: "Método de pago",     _style: "width:10%" },
  { key: "efectivo",       label: "Efectivo",           _style: "width:8%"  },
  { key: "otros",          label: "Otros",              _style: "width:8%"  },
  { key: "amount",         label: "Total cobrado",      _style: "width:8%"  },
  // { key: "status",         label: "Estado",             _style: "width:5%"  },
];

const fieldsExpenses = [
  { key: "index",          label: "N°",          _style: "width:1%"  },
  { key: "date_formatted", label: "Fecha",       _style: "width:10%" },
  { key: "description",    label: "Descripción", _style: "width:30%" },
  // { key: "type_name",      label: "Tipo",        _style: "width:15%" },
  { key: "amount",         label: "Monto",       _style: "width:10%" },
];

export default {
  name: "ReportUtilities",
  components: { CTableWrapper, cModalEgresos},
  data() {
    return {
      prefix: "report",
      fields,
      fieldsExpenses,
      data: [],
      expenses: [],
      selectedMonth: moment().locale("es").format("MMMM").toLowerCase(),
      monthOptions: [
        { value: "enero",      label: "Enero"      },
        { value: "febrero",    label: "Febrero"    },
        { value: "marzo",      label: "Marzo"      },
        { value: "abril",      label: "Abril"      },
        { value: "mayo",       label: "Mayo"       },
        { value: "junio",      label: "Junio"      },
        { value: "julio",      label: "Julio"      },
        { value: "agosto",     label: "Agosto"     },
        { value: "septiembre", label: "Septiembre" },
        { value: "octubre",    label: "Octubre"    },
        { value: "noviembre",  label: "Noviembre"  },
        { value: "diciembre",  label: "Diciembre"  },
      ],
      modalEgresos: {
        title: "EGRESOS",
        modal_form: false,
        item: {},
      },
    };
  },
  computed: {
    cp_button: function () {
      return false
    },
    totalIngresos() {
      return this.data
        .reduce((sum, item) => sum + parseFloat(item.amount || 0), 0)
        .toFixed(2);
    },
    totalEgresos() {
      return this.expenses
        .reduce((sum, item) => sum + parseFloat(item.amount || 0), 0)
        .toFixed(2);
    },
    utilidad() {
      return (parseFloat(this.totalIngresos) - parseFloat(this.totalEgresos)).toFixed(2);
    },
  },
  created() {
    moment.locale("es");
    this.mtd_data();
  },
  methods: {
    ...mapActions(["get", "post"]),
    closeModalEgreso: function () {
      this.modalEgresos.modal_form = false;
    },
    mtd_data() {
      this.data = [],
      this.expenses = [],
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/utilities",
        token: this.$store.getters.get__token,
        params: {
          month:      this.selectedMonth,
          campu_id:   this.$store.getters.get_campu.id,
          company_id: this.$store.getters.get_company.id,
        },
      })
        .then((response) => {
          this.processCharges(response.data.data);
          this.processExpenses(response.data.expenses);
        })
        .catch((error) => {
          console.error(error);
          this.$swal.fire({ title: "Error al cargar datos", icon: "error" });
        });
    },

    processCharges(charges) {
      let index = 1;
      this.data = charges.map((charge) => {
        const sale  = charge.sale  ?? null;
        const quote = sale?.quote?.[0] ?? null;

        const name_client = sale?.client
          ? `${sale.client.name ?? ""} ${sale.client.last_name ?? ""}`.trim()
          : "Sin cliente";

        const barbers = quote?.barber_detail?.length
          ? quote.barber_detail
              .map((d) => d.barber ? `${d.barber.name} ${d.barber.last_name}` : "Desconocido")
              .join(", ")
          : "Sin personal";

        let services = quote?.detail?.map((d) => `${d.name_service} (${d.quantity})`) ?? [];
        if (sale?.detail_product) {
          try {
            const prods = JSON.parse(sale.detail_product);
            services = services.concat(prods.map((p) => p.name));
          } catch (_) {}
        }

        const method   = charge.method ?? "No especificado";
        const amount   = parseFloat(charge.amount ?? 0).toFixed(2);
        const efectivo = method === "EFECTIVO" ? amount : "0.00";
        const otros    = method !== "EFECTIVO" ? amount : "0.00";
        const stateMap = { 1: "Reservado", 2: "En curso", 3: "Terminado" };

        return {
          index:          index++,
          date_formatted: moment(charge.created_at).format("DD/MM/YYYY"),
          name_client,
          barbers,
          services:       services.join(", ") || "Sin servicios",
          method,
          efectivo,
          otros,
          amount,
          status:         stateMap[sale?.state] ?? "Desconocido",
        };
      });
    },

    processExpenses(expenses) {
      let index = 1;
      this.expenses = expenses.map((expense) => ({
        index:          index++,
        date_formatted: expense.date
          ? moment(expense.date).format("DD/MM/YYYY")
          : moment(expense.created_at).format("DD/MM/YYYY"),
        description:    expense.fixed_expense?.name ?? expense.motive ?? "Sin descripción",
        amount:         parseFloat(expense.amount ?? 0).toFixed(2),
      }));
    },

    mtdBack() {
      this.$emit("mtdBack");
    },

    mtd_open_modal(){
      this.modalEgresos.modal_form = true;
      
    }
  },
};
</script>